import { render, staticRenderFns } from "./Wx_home.vue?vue&type=template&id=25e73c47&scoped=true&"
import script from "./Wx_home.vue?vue&type=script&lang=js&"
export * from "./Wx_home.vue?vue&type=script&lang=js&"
import style0 from "./Wx_home.vue?vue&type=style&index=0&id=25e73c47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e73c47",
  null
  
)

export default component.exports